module.exports = __webpack_public_path__ + "img/w66b.151fef8e.jpg";